<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">リダイレクト設定</h2>
        <v-form ref="form" class="mb-5">
          <v-row align="center">
            <v-col cols="3">
              <v-text-field
                v-model="mediaRedirection.convertOriginalPath"
                label="リダイレクト元のパス"
                placeholder="/1234"
                required
                :rules="inputRules"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="mediaRedirection.convertRedirectPath"
                label="リダイレクト先のURL"
                placeholder="http://example.com/12345"
                required
                :rules="inputRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="mediaRedirection.httpStatus"
                label="HTTPステータス"
                placeholder="HTTPステータス"
                :items="httpStatusTypes"
                item-text="type"
                item-value="value"
                required
                :rules="inputRules"
              ></v-select>
            </v-col>
            <v-col cols="1" align="center">
              <v-btn color="primary" outlined @click="createMediaRedirection">
                作成
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

        <v-form>
          <v-row
            v-for="(value, index) in mediaRedirections"
            :key="index"
            align="center"
          >
            <v-col cols="3">
              <v-text-field
                v-model="value.convertOriginalPath"
                class="mb-0 caption"
                label="リダイレクト元のパス"
                required
                placeholder="パス名"
                :rules="inputRules"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="value.convertRedirectPath"
                class="mb-0 caption"
                label="リダイレクト先のURL"
                required
                placeholder="URL"
                :rules="inputRules"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="value.httpStatus"
                label="HTTPステータス"
                :items="httpStatusTypes"
                item-text="type"
                tem-value="value"
                hide-selected
                required
                placeholder="HTTPステータス"
                :rules="inputRules"
              />
            </v-col>
            <v-col cols="1" align="center">
              <v-btn
                color="green darken-1"
                outlined
                @click="updateMediaRedirection(index)"
              >
                更新
              </v-btn>
            </v-col>
            <v-col cols="1" align="center">
              <v-btn
                color="error"
                outlined
                @click="deleteMediaRedirection(index)"
              >
                削除
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <infinite-loading @infinite="fetchMediaRedirections">
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。</v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import InfiniteLoading from 'vue-infinite-loading'
import snakecaseKeys from 'snakecase-keys'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    InfiniteLoading,
    snakecaseKeys
  },
  mixins: [headUtilsMixin],
  data: function () {
    return {
      pageTitle: 'リダイレクト設定',
      mediaRedirections: [],
      mediaRedirection: {
        convertOriginalPath: null,
        convertRedirectPath: null,
        httpStatus: null,
        id: null
      },
      inputRules: [(v) => !!v || '値を入力してください'],
      page: 1
    }
  },
  computed: {
    ...mapState({
      mediaRedirectionI18ns: (state) => state.I18n.enums.mediaRedirection
    }),
    httpStatusTypes: function () {
      if (this.mediaRedirectionI18ns == null) {
        return []
      }
      const httpStatusTypeI18n = snakecaseKeys(this.mediaRedirectionI18ns.httpStatus)
      const keys = Object.keys(httpStatusTypeI18n)
      let httpStatusTypes = []
      keys.forEach((key) => {
        httpStatusTypes.push({ type: httpStatusTypeI18n[key], value: key })
      })
      return httpStatusTypes
    }
  },
  methods: {
    fetchMediaRedirections ($state) {
      axios
        .get('/api/media_redirections', {
          params: {
            page: this.page
          }
        })
        .then(({ data }) => {
          const deserializedData = deserialize(data).data
          if (deserializedData.length) {
            this.page++
            this.mediaRedirections = this.mediaRedirections.concat(
              deserializedData
            )
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    createMediaRedirection: function () {
      axios.post('/api/media_redirections', this.mediaRedirection).then(
        ({ data }) => {
          const payload = {
            status: 200,
            message: 'リダイレクト設定を作成しました'
          }
          const deserializedData = deserialize(data).data
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.mediaRedirections.push(deserializedData)
          this.$refs.form.reset()
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },

    deleteMediaRedirection (index) {
      axios
        .delete(
          `/api/media_redirections/${this.mediaRedirections[index].id}`,
          this.mediaRedirection[index]
        )
        .then(() => {
          const payload = {
            status: 200,
            message: 'リダイレクト設定を削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.mediaRedirections.splice(index, 1)
        })
    },
    updateMediaRedirection (index) {
      axios
        .patch(
          `/api/media_redirections/${this.mediaRedirections[index].id}`,
          this.mediaRedirections[index]
        )
        .then(
          ({ data }) => {
            const payload = {
              status: 200,
              message: 'リダイレクト設定を更新しました'
            }
            const deserializedData = deserialize(data).data
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.mediaRedirections[index] = deserializedData
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>
